import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as AnalyticsActions from './analytics.actions';
import { AnalyticsService } from '../services/analytics.service';

@Injectable()
export class AnalyticsEffects {

  private actions$: Actions = inject(Actions);
  private analyticsService: AnalyticsService = inject(AnalyticsService);

  getAnalyticsDailyProgress = createEffect(() => this.actions$.pipe(
    ofType(AnalyticsActions.getAnalyticsDailyProgress),
    exhaustMap((action) => this.analyticsService.getDailyProgress(action.memberId).pipe(
      map((dailyProgress) => AnalyticsActions.setAnalyticsDailyProgress({ dailyProgress })),
      catchError((error) => of(AnalyticsActions.getDataFailure({ error }))),
    ))
  ));
}
